// extracted by mini-css-extract-plugin
export default {"container":"NotesOrderForm_container__D2Y2z","label":"NotesOrderForm_label__gJwzY"};